import { motion } from "framer-motion";
import { EASE } from "./Reveal";

const line = (text, delay) => (
  <span className="block overflow-hidden">
    <motion.span
      className="block font-display text-xs md:text-sm tracking-[0.5em] text-cream/70"
      initial={{ y: "110%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 0.7, delay, ease: EASE }}
    >
      {text}
    </motion.span>
  </span>
);

export default function Preloader() {
  return (
    <motion.div
      data-testid="preloader"
      className="fixed inset-0 z-[150] bg-ink flex flex-col items-center justify-center"
      exit={{ y: "-100%" }}
      transition={{ duration: 0.8, ease: EASE }}
    >
      <motion.img
        src="/logo.png"
        alt="INT–EXT"
        className="w-44 md:w-60 mb-8 mix-blend-screen"
        initial={{ opacity: 0, scale: 0.92 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6, ease: EASE }}
      />
      <div className="flex gap-6 md:gap-10">
        {line("INTERIOR", 0.25)}
        {line("EXTERIOR", 0.35)}
        {line("PRODUCTS", 0.45)}
      </div>
      <div className="w-44 md:w-60 h-px bg-white/10 mt-10 overflow-hidden">
        <motion.div
          data-testid="preloader-progress"
          className="h-full bg-gold origin-left"
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ duration: 1.1, delay: 0.15, ease: "easeInOut" }}
        />
      </div>
    </motion.div>
  );
}
